import * as prismicH from '@prismicio/helpers'

export const linkResolver: prismicH.LinkResolverFunction<string> = (doc) => {
	// Fallback for other types, in case new custom types get created
	if (doc.uid === 'login') return '/'
	return `/${doc.uid}`
}
